import ApplicationAdapter from './application';

export default class IdScanSessionAdapter extends ApplicationAdapter {
  urlForCreateRecord(modelName, snapshot) {
    const url = super.urlForCreateRecord(modelName, snapshot);
    return `${url}/submit`;
  }
}
